export const emptyCustomer = { name: "", email: "", phone: "", address_line1: "", address_line2: "", city: "", county: "", postcode: "", country: "Ireland" };

const FIELDS = [
  ["name", "Full name", { required: true, autoComplete: "name" }],
  ["email", "Email", { required: true, type: "email", autoComplete: "email" }],
  ["phone", "Phone", { required: true, type: "tel", autoComplete: "tel", minLength: 5 }],
  ["address_line1", "Address line 1", { required: true, autoComplete: "address-line1" }],
  ["address_line2", "Address line 2 (optional)", { autoComplete: "address-line2" }],
  ["city", "Town / city", { required: true, autoComplete: "address-level2" }],
  ["county", "County", { autoComplete: "address-level1" }],
  ["postcode", "Eircode / postcode", { autoComplete: "postal-code" }],
  ["country", "Country", { required: true, autoComplete: "country-name" }],
];

export const CustomerForm = ({ value, onChange, contactOnly = false, note }) => (
  <div className="space-y-3" data-testid="customer-form">
    <div className="font-display text-lg font-extrabold uppercase">{contactOnly ? "Contact details" : "Delivery details"}</div>
    {contactOnly && <p className="text-xs text-slate-500" data-testid="customer-contact-only-note">{note || "No address needed – your shield is delivered with your squad to your coach or club."}</p>}
    <div className="grid grid-cols-2 gap-3">
      {FIELDS.filter(([k]) => !contactOnly || ["name", "email", "phone"].includes(k)).map(([k, label, props]) => (
        <label key={k} className={`block text-xs font-bold uppercase tracking-wider text-slate-600 ${["county", "postcode"].includes(k) ? "" : "col-span-2"}`}>
          {label}
          <input {...props} value={value[k]} onChange={(e) => onChange({ ...value, [k]: e.target.value })} data-testid={`customer-${k}-input`}
            className="mt-1 w-full border-2 border-slate-200 bg-white px-3 py-2 text-sm font-semibold normal-case tracking-normal text-slate-900 outline-none focus:border-slate-900" />
        </label>
      ))}
    </div>
  </div>
);
